import { render, staticRenderFns } from "./ImageMapMessagePreview.vue?vue&type=template&id=5b2ee5d8&scoped=true&"
import script from "./ImageMapMessagePreview.vue?vue&type=script&lang=js&"
export * from "./ImageMapMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageMapMessagePreview.vue?vue&type=style&index=0&id=5b2ee5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ee5d8",
  null
  
)

export default component.exports